import "./TestConfigurationViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import TestConfigurationViewComponent from "./test-configuration-view/TestConfigurationViewComponent";
import TestConfigurationEditComponent from "./test-configuration-edit/TestConfigurationEditComponent";

interface TestPanelConfigurationViewEditComponentProps {
    testDetails: any
    onUpdateInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const TestConfigurationViewEditComponent = (props: TestPanelConfigurationViewEditComponentProps) => {
    const {testDetails, onUpdateInformation, onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [panelConfigurationInformation, setPanelConfigurationInformation] = useState<any>(undefined);

    const handleInformationUpdate = useCallback((updatedPanelInformation: any) => {
        onUpdateInformation(updatedPanelInformation);
        setMode("view");
    }, [onUpdateInformation]);

    const handlePanelInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (testDetails) {
            setPanelConfigurationInformation(testDetails);
        }
    }, [testDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])

    return (
        <div className="panel-configuration-component details-tab-data-wrapper">
            {
                mode === "view" && <TestConfigurationViewComponent
                    testDetails={panelConfigurationInformation}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <TestConfigurationEditComponent
                    testDetails={panelConfigurationInformation}
                    onUpdateComplete={handleInformationUpdate}
                    onEditCancel={handlePanelInformationEditCancel}
                />
            }
        </div>
    )

};

export default TestConfigurationViewEditComponent;